require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/queue.template.htm');
require('dhtmlxMessage');
var Model = require('../models/queues.model.ts');
var OrganizationsOptions = require("views/organizations_options.view.ts");
var VenuesOptions = require("views/venues_options.view.ts");
var AgentsOptions = require("views/agents_options.view.ts");
var CountersOptions = require("views/counters_options.view.ts");
var ServiceTimePicker = require("views/service_time_picker.view.ts");
var i18n = require('l10n');
var croppie = require('../../libs/croppie/js/croppie.js');


var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
    counterFlag: false,
    agentFlag: false,
    photoUrl: null,
	initialize: function (options) {
	    var self = this;
	    this.id = options ? options.id : null;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

	    if(this.id)
        {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                },
                error: function(response, xhr, status)
                {

                }
            });
        }
        else
        {
            this.editable = false;
            this.model = new Model();
            this.render();
        }

        this.fields =
        {
            name: [this.isEmpty],
            englishName: [this.isEmpty],
            queue_macro: [this.isEmpty, this.minLengthNumber, this.noSpaces],
            ticket_number_max: [this.isEmpty, this.isNotNumeric],
            max_ticker_per_customer: [this.isNotNumeric],
            queue_type: [this.isNotSelect],
            minimum_service_time: [this.isEmpty, this.isNotNumeric, this.isLessThan], //isLessThan than `notification_time_after_service`
            notification_time_after_service: [this.isEmpty, this.isNotNumeric]
        }
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable });
		//make sure that when the queue is saved (after editing), the current image will remain intact and not be deleted
		this.photoUrl = data.imagePath;
		this.hasImage = data.imagePath != null;

        this.$el.html(this.template(data));

        this.initTools(data);
        this.serviceTimePicker = new ServiceTimePicker( { serviceTimes: data.serviceTimes } );


	},
	events: {
        "click #submitBack": "clickOnSubmitBack",
        "click #reset": "clickOnReset",
        "click #cancel": "goBack",
        "change #organizations select": "changeOrganizations",
        "change #venues select": "changeVenues",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "focusout .to-validation input": "validateIt",
        "keypress  input[type=onlyNumbers]": "onlyNumbers",
        "keyup #description textarea": "validateDescription",
        "click #uploadPhoto": "upload_photo",
        "click #removePhoto": "remove_photo",
        "click #previewPhoto": "preview_photo",
        "change .smsCheckbox": "toggleForSms",
        "input .tellodyCampaignId": "checkTellodyCampaignId",
        "change #queueType": "changeQueueType",
        "change #soundMessageType": "changeQueueAudio"
	},
	checkTellodyCampaignId: _.debounce(function(e) {
	    var $element = $(e.currentTarget);
	    var value = $element.val();

	    if(value == null || value == "" || isNaN(value) || parseInt(value) <= 0 || (parseFloat(value) % 1 != 0)) {

            var text = i18n.t("queue.nonNumericValue");

            if(parseInt(value) <= 0)
                text = i18n.t("queue.valueMoreThan", {value: 0})

            $element.notify(text,
            {
                position:"top center",
                className: "error",
                autoHide: true
            });
        }
	}, 250),
    toggleForSms: function(e) {
        this.toggleTellodyCampaignId(e);
        this.toggleCustomMessageField(e);
    },
	toggleTellodyCampaignId: function(e) {
	    var $element = $(e.currentTarget);
	    var $input = $(e.currentTarget).parent().parent().find(".tellodyCampaignId");

	    var checked = $element.prop("checked");

	    if(checked)
	        $input.show();
	    else
	        $input.hide();
	},
    toggleCustomMessageField: function(e) {
	    var $element = $(e.currentTarget);
	    var $input = $(e.currentTarget).parent().parent().find(".customSmsMessage");

	    var checked = $element.prop("checked");

	    if(checked)
	        $input.show();
	    else
	        $input.hide();
	},
	existMacro: _.debounce(function(event) {

        var self = this;
        var element = $(event.target)
        var newMacro = element.val();
        $.ajaxq.abort("DefaultQueue");
        if((this.model.get("queueMacro") == null || this.model.get("queueMacro") == "") || ( this.model.get("queueMacro").toUpperCase() != newMacro.toUpperCase()))
        {


            element.parent().find("i").show();

            self.noUniqueMacro = false;

            $.ajaxDefaultQ({
                url: '/rest/api/queues/exists?acronym='+encodeURIComponent(newMacro),
                type: 'GET',
            }).done(function(response, status, xhr){
                element.parent().find("i").hide();
                if(response.data.value)
                {
                    self.noUniqueMacro = true;
                    self.setError(element.parent(), i18n.t("queue.NonUniqueMacro"));
                }
                 else
                    self.clearError(element.parent());
            })
            .fail(function(response) {
               element.parent().find("i").hide();
               console.info(response);
            });
        }
        else
        {
             this.clearError(element.parent());
        }

	}, 250),
	upload_photo: function(e) {
	    var self = this;
        $("input[name=file]").change(function () {
            if (this.files && this.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    self.photoUrl = e.target.result;
                    $('#queue_img').show();
                    $('#actionsP').show();
                    if(!self.croppie)
                        self.croppie = $('#queue_img').croppie({
                            url: self.photoUrl,
                            enableExif: true,
                            viewport: {
                                width: 256,
                                height: 256,
                                type: 'circle'
                            }
                        });
                };

                reader.readAsDataURL(this.files[0]);
            }
        });
	},
	cropPhoto: function() {
	    return this.croppie ? this.croppie.croppie('result') : null;
	},
	preview_photo: function() {
	    var self = this;
	    if (this.croppie) {
	        this.croppie.croppie('result').then(function(imgSrc) {
                self.popup(imgSrc);
            });
	    }
	    else
	    {
	        this.popup(this.model.get("imagePath"));
	    }

	},
	popup: function(imgSrc) {
	    dhtmlx.alert({
            type: "alert",
            text: "<div style='background-color:#e1e1e1;' class='imageQueuePreview'><img style='float:inherit; margin:0 auto; padding:10px 0;' src='"+ imgSrc +"'/></div>"
        });
	},
	remove_photo: function()
	{
        $('#actionsP').hide();
        $('#uploadPhoto').show();
        this.photoUrl = null;

        $('#queue_img').croppie('destroy');
        $('#queue_img').html("");
        this.croppie = null;
	},
	clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#queue_macro").find("input").val("");
        $("#ticket_number_max").find("input").val("");
        $("#max_ticker_per_customer").find("input").val("");
        $("#description").find("textarea").val("");
    },
	validateDescription: function()
    {
	    this.characterLeft("#description");
    },
	clickOnSubmitBack: function(e)
    {
       var self = this;
       this.back = true;

       $.when(this.cropPhoto()).then(function(imgSrc) {
            if(!imgSrc && self.hasImage && self.photoUrl) {
                //console.error("Image remained the same");
                self.photoUrl = self.model.get("imagePath");
            }else if(imgSrc) {
                self.photoUrl = imgSrc;
                //console.error("Image changed");
            }else if(!imgSrc && !self.hasImage) {
                self.photoUrl = null;
                //console.error("no image at all");
            }else if(!imgSrc && self.hasImage && !self.photoUrl) {
                self.photoUrl = null;
                //console.error("image deleted");
            }else {
                //should never occur
                console.error("NONE OF THE ABOVE");
            }

            var smsData = self.checkAndGetSmsData();

            if(smsData == null) {
                $.notify(i18n.t("queue.checkboxIssue"), {position:"top center", className: "error"});
                return;
            }

            var modelSmsData = $.extend({}, self.model.get("smsData"), smsData);

            self.model.set("smsData", modelSmsData);

            self.clickOnSubmit(null);
       });
    },
    checkAndGetSmsData: function() {
        var smsData = {
            "welcomeSms": false,
            "reminderSms": false,
            "servicingSms": false,
            "closureSms": false,
            "surveySms": false,
            "evaluationSms": false,

            "welcomeSmsCampaignId": null,
            "reminderSmsCampaignId": null,
            "closureSmsCampaignId": null,
            "surveySmsCampaignId": null,
            "servicingSmsCampaignId": null,
            "evaluationSmsCampaignId": null,

            "messageWelcome": null,
            "messageReminder": null,
            "messageServicing": null,
            "messageClosure": null
        }

        var smsCheckbox = [
            $("#welcomeSms"),
            $("#reminderSms"),
            $("#servicingSms"),
            $("#closureSms"),
            $("#surveySms"),
            $("#evaluationSms")
        ];

        var smsIds = [
            $("#welcomeSmsCampaignId"),
            $("#reminderSmsCampaignId"),
            $("#servicingSmsCampaignId"),
            $("#closureSmsCampaignId"),
            $("#surveySmsCampaignId"),
            $("#evaluationSmsCampaignId")
        ];

        var smsMessages = [
            $("#messageWelcome"),
            $("#messageReminder"),
            $("#messageServicing"),
            $("#messageClosure")
        ];

        var checkboxStatus = false;
        var message = "";
        var hasIssue = false;

        $.each(smsCheckbox, function(key, value) {
            var flag = $(this).find(".smsCheckbox").prop("checked");
            var id = smsIds[key].val();

            var checkboxStatus = false;
            var campaignId = null;

            if(flag && (id == null || id == "" || isNaN(id) || id <= 0 || (parseFloat(id) % 1 != 0))) {

                if(hasIssue)
                    return;

                hasIssue = true;

                var text = i18n.t("queue.nonNumericValue");

                if(parseInt(id) <= 0)
                    text = i18n.t("queue.valueMoreThan", {"value": 0})

                $(this).notify(text,
                {
                    position:"top center",
                    className: "error",
                    autoHide: true,
                    autoHideDelay: 10000
                });
            }
            else if(flag) {
                checkboxStatus = true;
                campaignId = !isNaN( parseInt(id.trim()) ) ? parseInt(id.trim()) : null;
            }
            //else is the values above IF condition

            var firstId = $(this).attr("id");
            var secondId = smsIds[key].attr("id");

            smsData[firstId] = checkboxStatus;
            smsData[secondId] = campaignId;

        });

        $.each(smsMessages, function(key, value) {
            var flag = $(this).parent().parent().find(".smsCheckbox").prop("checked");
            var messageValue = smsMessages[key].val();

            if(flag === true) {
                message = (messageValue.trim() !== "" && messageValue !== null) ? messageValue.trim() : null;
                var id = smsMessages[key].attr("id");
                smsData[id] = message;
            } else if(flag === false) {
                var id = smsMessages[key].attr("id");
                smsData[id] = null;
            }
        });

        if(hasIssue)
            return null;

        return smsData;

    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var has_error = this.validateFields(this.fields);
        has_error = this.validateDescription() || has_error;

        has_error = this.countersOptions.isTheDataWrong() || has_error;
        has_error = this.serviceTimePicker.hasError() || has_error;
        has_error = this.venuesOptions.isTheDataWrong() || has_error;
        has_error = this.organizationsOptions.isTheDataWrong() || has_error;
        has_error = this.noUniqueMacro || has_error;

        if(!has_error)
        {
            var tempModel = this.model.clone();
            var type = $("#queueType").find(":selected").val();
            var soundMessageType = $("#soundMessageType").find(":selected").val();

            this.model.set("name", $("#name").find("input").val());
            this.model.set("queueMacro", $("#queue_macro").find("input").val());
            this.model.set("maxTicketNum",$("#ticket_number_max").find("input").val());
            this.model.set("imagePath", this.photoUrl);
            this.model.set("minServiceTime", $("#minimum_service_time").find("input").val());
            this.model.set("notificationTimeAfterCalled", $("#notification_time_after_service").find("input").val());
            this.model.set("englishName", $("#englishName").find("input").val());
            this.model.set("type", $("#queueType").find(":selected").val());
            this.model.set("searchable", $("#queuePriority").find(":selected").val());
            this.model.set("servicingLetter", type == "COUNTER" ? $("#ticketPrefix").find(":selected").val() : null);
            this.model.set("soundMessageType", soundMessageType);
            this.model.set("soundMessage", soundMessageType == "CUSTOM" ? $("#soundMessage").val() : null);

            var isImmediateIssue = $("#automaticTicketIssue").find("input").prop("checked");

            this.model.set("immediateIssue", isImmediateIssue);

            var isTicketIssueManually = $("#ticketIssueManually").find("input").prop("checked");

            this.model.set("ticketIssueManually", isTicketIssueManually);

            var isNeedsPreparation = $("#needsPreparation").find("input").prop("checked");

            this.model.set("needsPreparation", isNeedsPreparation);

            var maxTicketPerCustomer = $("#max_ticker_per_customer input").val().trim();

            if( maxTicketPerCustomer == "" )
                 this.model.set("maxTicketsPerCustomer", 1);
            else
                 this.model.set("maxTicketsPerCustomer", maxTicketPerCustomer);

            this.model.set("serviceTimes", this.serviceTimePicker.getData( this.model.get("id") ));
            if ($("#description").find("textarea").val() != "")
                this.model.set("description", $("#description").find("textarea").val());
            else
                this.model.set("description", null);

            this.model.set("venueId", this.venuesOptions.getData());
            if(!this.editable)
            {
                this.model.set("orgId", this.organizationsOptions.getData());
            }

            this.model.set("status", this.intToStatus($("#queue_status select").val()));

            this.showActionProgressBar();

            var canItSaveAgents = !this.model.attributes.openNow || (this.model.attributes.openNow && !this.agentsOptions.areAgentsToBeDeleted());
            var canItSaveCounters = !this.model.attributes.openNow || (this.model.attributes.openNow && !this.countersOptions.areCountersToBeDeleted());


            if(!canItSaveAgents || !canItSaveCounters) {
                $.notify(i18n.t("queue.canNotRemoveAgentsCountersOnOpenQueue"));
                return;
            }


            this.model.save(null, {
                success: function(model, response)
                {
                    if(!self.editable)
                    {
                        self.agentsOptions.setNewQueueId(self.model.get("id"));
                        self.countersOptions.setNewQueueId(self.model.get("id"));
                    }

                    var countersSaved = function() {
                        var countersDeferred = $.Deferred();
                        self.countersOptions.updateData({
                            success: function() {
                                countersDeferred.resolve(true);
                            },
                            fail: function() {
                                countersDeferred.reject(false);
                            }
                        });
                        return countersDeferred.promise();
                    }

                    var agentsSaved =  function() {
                        var agentsDeferred = $.Deferred();
                        self.agentsOptions.updateData({
                            success: function() {
                                agentsDeferred.resolve(true);
                            },
                            fail:  function() {
                                agentsDeferred.reject(false);
                            }
                        });
                        return agentsDeferred.promise();
                    };

                    $.when(countersSaved(), agentsSaved()).then(function(countersResp, agentsResp) {
                        var type = self.editable ? i18n.t("queue.updated") : i18n.t("queue.added");

                        if(countersResp && agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully"), { position:"top center", className: "success" });
                        else if(countersResp && !agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveAgents"), { position:"top center", className: "success" });
                        else if(!countersResp && agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCounters"), { position:"top center", className: "success" });
                        else {
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCountersAndAgents"), { position:"top center", className: "success" });
                        }

                        setTimeout(self.goBack, 1000);
                    });

                    self.hideActionProgressBar();
                },
                error: function(model, response)
                {
                    self.model = tempModel;
                    self.hideActionProgressBar();
                }
            });
        }
        else
        {
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }
    },
    validateIt: function(event)
    {
        if(event.which > 36 && event.which < 41)
            return;

        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        var has_error = this.validateFields( field );

        if(!has_error)
        {
            this.extendedValidations(event);
        }
    },
    extendedValidations: function(event)
    {
        switch(event.originalEvent.type)
        {
            case "keyup":
               switch(event.target.id)
               {
                    case "qacronym":
                        this.existMacro(event);
                    break;
               }
            break;
        }
    },
	changeOrganizations: function()
    {
        this.venuesOptions.load( {org: this.organizationsOptions.getData() } );
        this.clearError("#organizations");
    },
    changeVenues: function()
    {
        this.agentsOptions.load(this.venuesOptions.getData());
        this.clearError("#venues");
    },
    intToStatus: function(index)
    {
        switch(Number(index))
        {
            case 0:
                return i18n.t("queue.open");
            case 1:
                return i18n.t("queue.closed");
            case 2:
                return i18n.t("queue.suspended");
        }
    },
    initTools: function(data)
    {
        var params =
        {
            userPrivilege: this.privilegeLevel
        };

    	this.agentsOptions = new AgentsOptions($.extend(params, { id: this.model.attributes.id, queueStatus: this.model.attributes.status} ));
		this.organizationsOptions = new OrganizationsOptions($.extend(params, { orgId: data.orgId } ));
		this.venuesOptions = new VenuesOptions($.extend(params, { venueId: data.venueId } ));
		this.countersOptions = new CountersOptions( {queueId: data.id} );

		if(!this.editable)
        {
            this.organizationsOptions.load();
        }
        this.venuesOptions.load();

        var venueId = 0;
        if( data )
            venueId = data.venueId;
        else if(this.venuesOptions.getData())
            venueId = this.venuesOptions.getData();

        this.agentsOptions.load( venueId );

    },
    changeQueueType: function() {
        var selected = this.$el.find('#queueType').find(":selected").val();

        if (selected == "COUNTER") {
            this.$el.find('.counter-extra-options').show();
        } else {
            this.$el.find('.counter-extra-options').hide();
        }

        if (selected == "EXAMINATION_CHAMBER") {
            this.$el.find('.examination-chamber-ticket-issue-manually').show();
        } else {
            this.$el.find('.examination-chamber-ticket-issue-manually').hide();
        }
    },
    changeQueueAudio: function() {
        var selected = this.$el.find('#soundMessageType').find(":selected").val();

        if (selected == "CUSTOM") {
            this.$el.find('.soundMessage').show();
        } else {
            this.$el.find('.soundMessage').hide();
        }
    }

});

module.exports = TheView;